import React from "react";
import PropTypes from "prop-types";
import { Button } from "cxa-components";
import { formatWithHardcodedCurrency } from "components/common/FormattedComponents";
import { FormattedMessage, injectIntl, intlShape } from "react-intl";
import { isExist } from "cxa-utils";
import messages from "components/messagesDescription";
import StandardMoney from "../../../common/StandardMoney";

const BenefitCheckoutLegacyTable = ({
  items,
  subTotal = items.reduce((prev, { totalPrice = 0 } = {}) => prev + totalPrice, 0),
  currency,
  intl,
}) =>
  !!items.length && (
    <table className="apl-data-table">
      <thead>
        <tr key="header">
          <th>
            <FormattedMessage {...messages.productDescription} />
          </th>
          <th>
            <FormattedMessage {...messages.descriptionDescription} />
          </th>
          <th className="apl-payment__price" />
          <th className="apl-field__currency apl-payment__price">
            <FormattedMessage {...messages.priceDescription} />
          </th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <th colSpan="3">
            <FormattedMessage {...messages.subtotalDescription} />
          </th>
          <td className="apl-field__currency apl-payment__price">
            <StandardMoney value={subTotal} currency={currency} />
          </td>
        </tr>
      </tfoot>
      <tbody>
        {items.map(
          ({
            rowClassName,
            id,
            logo,
            name,
            planNameMessageDescription,
            displayValue,
            showUWSumAssured,
            guaranteed,
            subjectToUW,
            uWFormID,
            total: { price: { numericValue } = {} } = {},
          }) => {
            return [
              <tr className={rowClassName} key={`row-${id}`}>
                <td>
                  {logo && (
                    <img alt="" className="checkout__logo" src={`/assets/images/common/${logo}`} />
                  )}
                  <h4>
                    <FormattedMessage id={name} defaultMessage={name} />
                  </h4>
                </td>
                <td>
                  <h4>
                    <FormattedMessage {...planNameMessageDescription} />
                  </h4>
                  <p>
                    {isExist(displayValue) &&
                      `${intl.formatMessage(messages.optionTextDescription)}
                      ${intl.formatMessage({
                        id: displayValue,
                        defaultMessage: displayValue,
                      })} `}

                    {!!uWFormID && (
                      <Button
                        onClick={() => {
                          // eslint-disable-next-line security/detect-non-literal-fs-filename
                          //TO REMOVE FROM OLD uWFormID if you want to preview SINGLIFEHD202308 hdf ${uWFormID}
                          window.open(`/hdf/${uWFormID}`, "hdfWindow");
                        }}
                      >
                        <FormattedMessage {...messages.HDFDescription} />
                      </Button>
                    )}
                  </p>
                  {
                    // <PlanBased showUWPlanBased={showUWPlanBased} uWFormID={uWFormID} />
                  }
                </td>
                <td />
                <td className="apl-field__currency">
                  <StandardMoney value={numericValue} currency={currency} />
                </td>
              </tr>,
              !!(showUWSumAssured && guaranteed) && (
                <tr className={rowClassName}>
                  <td />
                  <td>
                    <FormattedMessage {...messages.guaranteedSumDescription} />{" "}
                    {formatWithHardcodedCurrency(guaranteed.label.numericValue)}
                  </td>
                  <td className="apl-field__currency">
                    <StandardMoney value={guaranteed.price.numericValue} currency={currency} />
                  </td>
                  <td />
                </tr>
              ),
              !!(showUWSumAssured && subjectToUW) && (
                <tr className={rowClassName}>
                  <td />
                  <td>
                    <FormattedMessage {...messages.underwritingSumDescription} />{" "}
                    {formatWithHardcodedCurrency(subjectToUW.label.numericValue)}
                  </td>
                  <td className="apl-field__currency">
                    <StandardMoney value={subjectToUW.price.numericValue} currency={currency} />
                  </td>
                  <td />
                </tr>
              ),
            ];
          }
        )}
      </tbody>
    </table>
  );

BenefitCheckoutLegacyTable.propTypes = {
  items: PropTypes.array.isRequired,
  currency: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(BenefitCheckoutLegacyTable);



// WEBPACK FOOTER //
// ./components/employee/shop/checkout/BenefitCheckoutLegacyTable.js